/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCharacter = `mutation CreateCharacter($input: CreateCharacterInput!) {
  createCharacter(input: $input) {
    id
    name
    role
    owner
  }
}
`;
export const updateCharacter = `mutation UpdateCharacter($input: UpdateCharacterInput!) {
  updateCharacter(input: $input) {
    id
    name
    role
    owner
  }
}
`;
export const deleteCharacter = `mutation DeleteCharacter($input: DeleteCharacterInput!) {
  deleteCharacter(input: $input) {
    id
    name
    role
    owner
  }
}
`;
